import React from 'react';

const GoogleSearchAd = ({
    finalUrl,
    headline1,
    headline2,
    description,
    sitelinks
}) => {
    finalUrl = finalUrl?.trim() || "www.example.com";
    headline1 = headline1?.trim() || "Headline 1";
    headline2 = headline2?.trim() || "Headline 2";
    description = description?.trim() || "Description";
    sitelinks = Array.isArray(sitelinks) && sitelinks.length
      ? sitelinks
      : ["Free Trial", "Sitelink text"];

    return (
        <div style={{
            // width: '295px',
            width: '100%',
            border: '1px solid #ddd',
            borderRadius: '0.5rem',
            padding: '0.75rem',
            fontFamily: 'Arial, sans-serif',
            fontSize: '0.75rem',
            backgroundColor: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        }}>
            <div style={{ color: '#5f6368', marginBottom: '0.3rem', fontSize: '0.65rem' }}>
                Sponsored
            </div>
            <a href={`https://${finalUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1a0dab', textDecoration: 'none', fontSize: '0.7rem', marginBottom: '0.2rem', display: 'inline-block' }}>
                <i className="fa fa-globe" style={{ marginRight: '4px' }} />
                {finalUrl}
            </a>
            <div style={{
                color: '#1a0dab',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                marginBottom: '0.2rem',
            }}>
                {headline1} - {headline2}
            </div>
            <div style={{ color: '#4d5156', marginBottom: '0.5rem' }}>
                {description}
            </div>
            <div>
                {sitelinks.map((link, index) => (
                    <span key={index} style={{
                        color: '#1a0dab',
                        marginRight: '0.5rem',
                        fontSize: '0.7rem',
                        cursor: 'pointer'
                    }}>
                        {link}{index < sitelinks.length - 1 && <span> · </span>}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default GoogleSearchAd;
